<template>
  <base-alert
    :modalId="'cancel-deadhead-trip-model-' + tripID"
    icon="popup-warning-icon"
    :title="$t('cancel-trip')"
    :description="$t('confirm-cancel') + ` #${tripID} ${isLangRtl ? '؟' : '?'}`"
  >
    <template #buttons>
      <base-button variant="secondary" @click="hideModal" class="col-3 mb-3">
        {{ $t("no") }}
      </base-button>
      <base-button variant="primary" @click="cancelTrip" class="col-3 mb-3">
        {{ $t("yes") }}
      </base-button>
    </template>
  </base-alert>
</template>

<script>
export default {
  props: ["tripID"],
  emits: ["cancelTrip"],
  methods: {
    hideModal() {
      this.$bvModal.hide("cancel-deadhead-trip-model-" + this.tripID);
    },
    cancelTrip() {
      this.$emit("cancelTrip");
      this.hideModal();
    },
  },
};
</script>